<template>
    <!-- 链接管理 -->
    <myPopup title="链接管理" :flag="isShow" newWidth="45" @close="close">
        <div class="linkAdmin">
            <!-- 顶部tab栏目 -->
            <div class="tabWrap">
                <div class="tabItem" :class="{'active': tabActive == 1}" @click="switchTab(1)">
                    积分任务
                </div>
                <div class="tabItem" :class="{'active': tabActive == 2}" @click="switchTab(2)">
                    积分乐园
                </div>
                <div class="tabItem" :class="{'active': tabActive == 3}" @click="switchTab(3)">
                    积分商城
                </div>
                <div class="tabItem" :class="{'active': tabActive == 4}" @click="switchTab(4)">
                    其它链接
                </div>
                <i class="line"></i>
            </div>

            <!-- 搜索 -->
            <div class="searchForm">
                <div class="item">
                    <label>活动名称: </label>
                    <el-input v-model="form.activityName"></el-input>
                </div>
                <div class="item">
                    <label>活动类型：</label>
                    <el-select v-model="form.activityType" placeholder="请选择">
                        <el-option
                            v-for="item in activityTypeList"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="handle">
                    <button class="search" @click="handleSearch">
                        <i class="el-icon-search" style=" margin-right: 4px;"></i>
                        查询
                    </button>
                    <button class="reset" @click="reset">重置</button>
                </div>
            </div>

            <!-- 表格 -->
            <table class="tabelData">
                <tr class="th">
                    <th style="flex: 2;">活动名称</th>
                    <th style="flex: 2;">活动类型</th>
                    <th style="flex: 2;">活动时间</th>
                    <th style="flex: 1;">操作</th>
                </tr>
                <tbody>
                    <tr class="tb" v-for="item in tabelList" :key="item.id">
                        <td style="flex: 2;">{{item.activityName}}</td>
                        <td style="flex: 2;">
                            <span v-if="item.activityType == 1">日历签到</span>
                            <span v-if="item.activityType == 3">每日抢好礼</span>
                            <span v-if="item.activityType == 4">关注店铺有礼</span>
                            <span v-if="item.activityType == 5">邀请开卡</span>
                            <span v-if="item.activityType == 6">邀请关注店铺</span>
                            <span v-if="item.activityType == 7">完善信息有礼</span>
                            <span v-if="item.activityType == 8">大转盘抽奖</span>
                            <span v-if="item.activityType == 9">积分兑换实物</span>
                            <span v-if="item.activityType == 10">积分兑换优惠券</span>
                        </td>
                        <td style="flex: 2;" class="time">
                            <span>起：{{item.startTime}}</span>
                            <span>止：{{item.endTime}}</span>
                        </td>
                        <td style="flex: 1;" class="handle" @click="handleSelect(item)">选择</td>
                    </tr>
                </tbody>

                <el-pagination
                    @current-change="handleCurrentChange"
                    class="pagination"
                    background
                    :page-size="form.size"
                    layout="total, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </table>
        </div>
    </myPopup>
</template>

<script>
import myPopup from '@/components/new_popup'
import {taskList, exchangeActivityList} from '@/api/paradiseAndTaskCommonController.js'

export default {
    props: {
        isShow: {
            type: Boolean,
            default: false
        }
    },
    components: {
        myPopup
    },
    data() {
        return {
            tabActive: 1,
            activityTypeList: [
                {value: '', label: '全部'},
                {value: 1, label: '日历签到'},
                {value: 3, label: '每日抢好礼'},
                {value: 4, label: '关注店铺有礼'},
                {value: 5, label: '邀请开卡'},
                {value: 6, label: '邀请关注店铺'},
                {value: 7, label: '完善信息有礼'},
                
            ],
            tabelList: [],
            form: {
                activityName: '',
                activityType: '',
                size: 10,
                current: 1
            },
            total: 0
        }
    },
    created() {
        this.getTaskList();
    },
    methods: {
        // 获取积分任务，积分乐园列表
        getTaskList() {
            taskList(this.form).then(res => {
                if(res && res.code == 1) {
                    this.total = +res.data.total
                    this.tabelList = res.data.records
                }
            })
        },
        // 获取礼品兑换列表
        getExchangeActivityList() {
            exchangeActivityList(this.form).then(res => {
                if(res && res.code == 1) {
                    this.total = +res.data.total
                    this.tabelList = res.data.records
                }
            })
        },
        // 选中链接
        handleSelect(data) {
            this.$emit('close', data);
            console.log(data);
        },
        // 查询
        handleSearch() {
            this.tabActive > 2 ? this.getExchangeActivityList() : this.getTaskList()
        },
        // tab栏切换
        switchTab(num) {
            // 1 积分任务 2 积分乐园 3 积分商城 4 其它链接
            this.tabActive = num;
            switch (num) {
                case 1:
                    this.form.activityType = '';
                    this.activityTypeList = [
                        {value: '', label: '全部'},
                        {value: 1, label: '日历签到'},
                        {value: 3, label: '每日抢好礼'},
                        {value: 4, label: '关注店铺有礼'},
                        {value: 5, label: '邀请开卡'},
                        {value: 6, label: '邀请关注店铺'},
                        {value: 7, label: '完善信息有礼'},
                    ]
                    this.getTaskList();
                    break;
                case 2: 
                    this.form.activityType = '';
                    this.activityTypeList = [
                        {value: 8, label: '大转盘抽奖'},
                    ]
                    this.getTaskList();
                    break;
                case 3:
                    this.form.activityType = '';
                    this.activityTypeList = [
                        {value: 9, label: '积分兑换实物'},
                        {value: 10, label: '积分兑换优惠券'},
                    ]
                    this.getExchangeActivityList();
                    break;
            }
        },
        //  重置
        reset() {
            this.form.activityName = '';
            this.form.activityType = '';
        },
        // 分页变化
        handleCurrentChange(val) {
            this.form.current = val;
            this.getTaskList();
        },
        // 取消
        close() {
            this.$emit('close', false);
        }
    }
}
</script>

<style scoped lang="scss">
.linkAdmin {
    box-sizing: border-box;
    padding: 20px 0 0 0;
    .tabWrap {
        display: flex;
        color: #666;
        font-size: 14px;
        font-weight: 400;
        .tabItem {
            width: 106px;
            height: 36px;
            line-height: 35px;
            border: 1px solid #DDDDDD;
            border-radius: 2px 2px 0px 0px;
            text-align: center;
            cursor: pointer;
            &.active {
                border-bottom: none;
                color: #FE4D45;
                font-weight: 500;
                border-top: 3px solid  #FE4D45;
                border-radius: 4px 4px 0px 0px;
            }
        }
        .line {
            flex: 1;
            border-bottom: 1px solid #ddd;
        }
    }
    .searchForm {
        display: flex;
        align-items: center;
        margin: 20px 0;
        .item {
            flex: 1;
            display: flex;
            align-items: center;
            margin-right: 30px;
            label {
                width: 90px;
                color: #333;
                font-size: 14px;
                white-space: nowrap;
            }
            /deep/ .el-input__inner {
                height: 32px !important;
            }
        }
        .handle {
            display: flex;
            align-items: center;
            button {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 98px;
                height: 32px;
                border-radius: 3px;
                font-size: 14px;
                font-weight: 400;
                transition: all .2s;
            }
            .search {
                margin-right: 8px;
                color: #FE4D45;
                border: 1px solid #FE4D45;
                &:hover {
                    background-color: #FE4D45;
                    color: #fff;
                }
            }
            .reset {
                color: #000;
                border: 1px solid rgba(0, 0, 0, 0.14901960784313725);
                &:hover {
                    border: 1px solid #FE4D45;
                    color: #FE4D45;
                }
            }
        }
    }
    .tabelData {
        width: 100%;
        color: #333;
        font-size: 14px;
        .th {
            display: flex;
            align-items: center;
            height: 40px;
            border: 1px solid #F3F3F3;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.04);
            font-weight: 500;
        }
        tbody {
            display: block;
            max-height: 185px;
            overflow: scroll;
            &::-webkit-scrollbar {
                width:7px;
                height:10px;
            }
            &::-webkit-scrollbar-track {
                border-radius: 2px;
            }
            &::-webkit-scrollbar-thumb {
                background: #ddd;
                border-radius:10px;
            }
            &::-webkit-scrollbar-thumb:hover {
                background: #ddd;
            }
        }
        .tb {
            display: flex;
            align-items: center;
            height: 60px;
            border-bottom: 1px solid #F3F3F3;
            font-weight: 400;
            .time {
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                span {
                    &:first-child {
                        margin-bottom: 6px;
                    }
                }
            }
            .handle {
                color: #FE4D45;
                cursor: pointer;
            }
        }
    }
    .pagination {
        margin-top: 20px;
        text-align: right;
    }
}
</style>